import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/OriginGateways'
import { Structure } from 'pages/NWPlatform/OriginGateways/Structure'
import { environmentRoute } from 'pages/NWPlatform/Routing'

export const originGatewaysRoute = createRoute({
  getParentRoute: () => environmentRoute,
  path: StaticRouteParameter.ORIGIN_GATEWAYS,
  loader: () => ({
    crumb: t('entity:publishing.originGateway', { count: 2 }),
  }),
})

export const originGatewaysLayoutRoute = createRoute({
  getParentRoute: () => originGatewaysRoute,
  id: 'originGatewaysLayout',
  component: Structure,
})

type OriginGatewaysOverviewSearch = {
  query?: string
}

export const originGatewaysOverviewRoute = createRoute({
  getParentRoute: () => originGatewaysLayoutRoute,
  path: '/',
  component: Overview,
  validateSearch: (search: Record<string, unknown>): OriginGatewaysOverviewSearch => {
    const result: Record<string, unknown> = {}

    if (search.query && typeof search.query === 'string' && !!search.query.length) {
      result.query = search.query
    }

    return result satisfies OriginGatewaysOverviewSearch
  },
})
